export default class SceneObject {

    constructor(sceneObject, componentName, parameters) {
        this._sceneObject = sceneObject;

        this.componentName = componentName;
        this.parameters = parameters;

        this.node = this._sceneObject.addNode();
        this.component = this.node.addComponent(this.componentName, this.parameters);

        this.node.start();
    }

}
